import { TooltipHost, IconButton } from "@fluentui/react";

export const EditableMenuNew = ({ seedKey, addMenuItem }) => {
  return (
    <TooltipHost content="Add New Item" id="SaveChangesButton">
      <IconButton
        iconProps={{ iconName: "Add" }}
        ariaLabel="Add New Item"
        onClick={() => {
          addMenuItem(seedKey);
        }}
      />
    </TooltipHost>
  );
};

export default EditableMenuNew;
